module.exports = __webpack_public_path__ + "static/media/remote-contorller-page-content.a613671e.png";